import * as React from "react";

const SvgCursorsNotAllowed = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <g filter="url(#cursors_not-allowed_svg__a)">
      <path
        fill="currentColor"
        d="M11.99 6.97 4.518 3.628l1.767 7.889L8.444 8.4z"
      />
    </g>
    <path
      fill="currentColor"
      fillRule="evenodd"
      stroke="currentColor"
      strokeOpacity={0.92}
      d="m4 3 8.916 3.986-4.23 1.708-2.577 3.717zM13.759 8.717c1.723 0 3.284.687 4.413 1.798a6.074 6.074 0 0 1 0 8.686A6.27 6.27 0 0 1 13.759 21a6.27 6.27 0 0 1-4.414-1.799 6.074 6.074 0 0 1 0-8.686 6.27 6.27 0 0 1 4.414-1.798Zm-3.527 4.204a3.93 3.93 0 0 0 .671 4.748c.73.718 1.74 1.163 2.856 1.163.715 0 1.386-.183 1.969-.503zm3.527-2.037c-.715 0-1.387.183-1.97.504l5.496 5.408.094-.175a3.93 3.93 0 0 0-.765-4.573 4.06 4.06 0 0 0-2.855-1.164Z"
      clipRule="evenodd"
    />
    <defs>
      <filter
        id="cursors_not-allowed_svg__a"
        width={13.474}
        height={13.889}
        x={1.517}
        y={1.628}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7313_8267"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_7313_8267"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgCursorsNotAllowed;
